import Keycloak from 'keycloak-js';

export const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_EP,
    realm: "pls",
    clientId: "pls-ui",
    onLoad: "login-required",
    pkceMethod: "S256",
    checkLoginIframe: false, // avoids silent refresh issues		
});

export class KeycloakService{
    static init()
    {
        console.log("KC URL:"+process.env.REACT_APP_KEYCLOAK_EP);
        return keycloak.init({onLoad: "login-required"});
    }
}
